import React from "react";
import { cardData4 } from "../Data/More_Data/clientInfoData";

const Client_testimonial = () => {
  return (
    <div className="testimonial-wrapper">
        <h2 className="testimonial-heading">What Our Clients Say</h2>
        <div className="testimonial-grid">
          {cardData4.map((card, index) => (
            <div
              className="testimonial-card"
              key={index}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <img src={card?.quoteIconSrc} alt="icon" />
              <p className="testimonial-text">{card.text}</p>
              <div className="testimonial-footer">
                <img className="avatar" src={card.avatarSrc} alt={card.name} />
                <div>
                  <div className="stars">★★★★★</div>
                  <h4 className="name">{card.name}</h4>
                  <p className="designation">{card.designation}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      {/* Internal Styles */}
      <style>{`
        .testimonial-wrapper {
          background: #f6f2f0;
          padding: 80px 20px;
          font-family: 'Segoe UI', sans-serif;
          text-align: center;
        }

        .testimonial-heading {
          font-size: 2.5rem;
          margin-bottom: 60px;
          color: #18336c;
          font-weight: bold;
        }

        .testimonial-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
          gap: 40px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .testimonial-card {
          background: #fff;
          border-radius: 16px;
          padding: 40px 30px;
          box-shadow: 0 12px 25px rgba(0, 0, 0, 0.06);
          text-align: left;
          position: relative;
          animation: fadeUp 0.6s ease forwards;
          opacity: 0;
          transform: translateY(30px);
        }

        .quote-icon {
          font-size: 80px;
          color: #2c1f1f;
          opacity: 0.1;
          position: absolute;
          top: 20px;
          left: 25px;
        }

        .testimonial-text {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #333;
          margin: 60px 0 30px 0;
          position: relative;
          z-index: 1;
        }

        .testimonial-footer {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .avatar {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #18336c;
        }

        .stars {
          color: #f5c518;
          font-size: 1rem;
          margin-bottom: 4px;
        }

        .name {
          font-weight: bold;
          margin: 0;
          font-size: 1.1rem;
          color: #000;
        }

        .designation {
          margin: 0;
          font-size: 0.95rem;
          color: #555;
        }

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 600px) {
          .testimonial-heading {
            font-size: 2rem;
          }

          .testimonial-card {
            padding: 30px 20px;
          }

          .quote-icon {
            font-size: 60px;
          }
        }
      `}</style>
    </div>
  );
};

export default Client_testimonial;
